module.exports = __webpack_public_path__ + "static/media/sem-imagem.f3845ea7.png";